import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { useOccDisplayText } from '../../../context/occ/hooks/use-occ-display-text';
import { Tabs, TabsDisplayType } from '../../../subcomponents/tabs';
import { getFilterLabel } from '../../../utils/filters/get-filter-label';
import { SingleFilterDisplayMode } from '../types/display-mode';
export const SingleFilterTabs = observer(props => {
    const { displayMode, options, onClick, filterKey, displayText } = props;
    const { allOptionLabel } = displayText;
    const occDisplayText = useOccDisplayText();
    const occConfig = useOccConfig();
    const i18n = useI18n();
    const tabDisplayType = displayMode === SingleFilterDisplayMode.PrimaryTab ? TabsDisplayType.Primary : TabsDisplayType.Secondary;
    const tabItems = useMemo(() => getTabDataForFilterOptions(options, filterKey, occConfig, occDisplayText, i18n, allOptionLabel), [options, filterKey, allOptionLabel, occConfig, occDisplayText, i18n]);
    const selectedOption = options.find(option => option.selected);
    if (!selectedOption)
        return null;
    const selectedTab = tabItems.find(item => item.value === selectedOption.value);
    if (!selectedTab)
        throw new Error('Cannot render SingleFilterTabs. Cannot find selected tab data.');
    return (_jsx(Tabs, { tabList: tabItems, displayType: tabDisplayType, onTabSelected: tab => onClick(tab.value), selectedTab: selectedTab }));
});
SingleFilterTabs.displayName = 'SingleFilterTabs';
const getTabDataForFilterOptions = (options, filterKey, config, displayText, i18n, allOptionLabel) => {
    return options.map(option => ({
        label: getFilterLabel(filterKey, option.value, config, displayText, i18n, allOptionLabel),
        value: option.value
    }));
};
